import { CVMIntlShape } from 'translate/languages/async/cvm88/pt'
import { preffixTestIds } from 'utility/e2e'

export const CVM_FORM_TEST_IDS = preffixTestIds('cvm-form')({
  SELECT: (id: string) => `select-${id}`,
  QUESTION: (
    id: keyof CVMIntlShape['translations']['cvm88']['form']['questions']
  ) => `question-${id}`,
})
